module.exports = __webpack_public_path__ + "img/tools_chats_768.f4cc23e.jpg";